import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminStats.css';
import { useNavigate } from 'react-router-dom';

const AdminStats = () => {
    const [stats, setStats] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get('/api/admin/stats');
                setStats(response.data);
            } catch (error) {
                console.error('Error fetching admin stats:', error);
            }
        };

        fetchStats();
    }, []);

    if (!stats) {
        return <div>Loading...</div>;
    }

    return (
        <div className="admin-stats">
            <h1>Admin Stats</h1>
            <div className="stats-container">
                <div className="stat-card" onClick={() => navigate('/admin/stats/last-month')}>
                    <h2>Games Created Last Month</h2>
                    <p>{stats.gamesCreatedLastMonth}</p>
                </div>
                <div className="stat-card">
                    <h2>New Accounts Last Month</h2>
                    <p>{stats.newAccountsLastMonth}</p>
                </div>
                {/* Add more stat cards here */}
            </div>
        </div>
    );
};

export default AdminStats; 
